/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Te_Summary_ExtremeInputs */

const en_ui_te_summary_extreme = /** @type {(inputs: Ui_Te_Summary_ExtremeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extreme session — high aerobic and anaerobic impact.`)
};

const de_ui_te_summary_extreme = /** @type {(inputs: Ui_Te_Summary_ExtremeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extreme Einheit — aerob und anaerob voll gefordert.`)
};

/**
* | output |
* | --- |
* | "Extreme session — high aerobic and anaerobic impact." |
*
* @param {Ui_Te_Summary_ExtremeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_te_summary_extreme = /** @type {((inputs?: Ui_Te_Summary_ExtremeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Te_Summary_ExtremeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_te_summary_extreme(inputs)
	return de_ui_te_summary_extreme(inputs)
});